const enum PushContentTypes {
    LOYALTY = 'loyalty',
}

export const enum PushContentTemplateTypes {
    LOYALTY_COMPLETE_TASK = 'loyalty_complete_task',
    LOYALTY_EARN_BADGE = 'loyalty_earn_badge',
    LOYALTY_NEW_BADGE = 'loyalty_new_badge',
}

const isPushContentTypeLoyalty = (pushContentType?: string | null): boolean => {
    return pushContentType?.toLowerCase() === PushContentTypes.LOYALTY;
};

export default {
    isPushContentTypeLoyalty,
};
